export const zh_HK = {
    title: '批准彈出窗口',
    content_sign: '點擊繼續完成簽名或交易',
    content_login: '點擊繼續完成創建或連接錢包',
};
